// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"280":"b252d21b","344":"3b4afd6d","837":"eab16338","918":"bc9fb656"}[chunkId] + ".chunk.css");